import { PaginaCrud } from '../components/PaginaCrud'
import type { Transportista } from '../types'

export default function Transportistas() {
  return (
    <PaginaCrud<Transportista>
      titulo="Transportistas"
      recurso="transportistas"
      llave="id"
      columnas={[
        { campo: 'codigo', titulo: 'Codigo' },
        { campo: 'nombre', titulo: 'Nombre' },
        { campo: 'licencia', titulo: 'Licencia', render: (t) => t.licencia || '-' },
        { campo: 'telefono', titulo: 'Telefono', render: (t) => t.telefono || '-' },
        { campo: 'activo', titulo: 'Activo', render: (t) => (t.activo ? 'Si' : 'No') },
      ]}
      campos={[
        { nombre: 'codigo', etiqueta: 'Codigo', tipo: 'texto', requerido: true },
        { nombre: 'nombre', etiqueta: 'Nombre', tipo: 'texto', requerido: true },
        { nombre: 'licencia', etiqueta: 'Licencia', tipo: 'texto' },
        { nombre: 'telefono', etiqueta: 'Telefono', tipo: 'texto' },
        { nombre: 'activo', etiqueta: 'Activo', tipo: 'checkbox' },
      ]}
      valorInicial={{ tenantId: 1, activo: true }}
    />
  )
}
